<template>
  <section class="pdf-content" style="margin: 10px 20px 15px 0px">
    <v-row no-gutters>
      <v-col cols="8" class="pa-0">
        <v-col class="provider-text">{{ planName }}</v-col>
        <v-col
          class="text-left date-text py-0 mt"
          style="padding-bottom: 0; padding-top: 0"
          align-self="end"
        >
          <strong>{{ $helpers.formatDateForPrint(new Date()) }}</strong>
        </v-col>
        <v-col class="text-left summary-text py-0" align-self="end">
          {{ title }}:
          {{ dates ? " " + dates[0] + " - " + dates[1] : " All" }}
        </v-col>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <img
          style="margin-top: 10px"
          class="text-right"
          :src="require('@/assets/logo.png')"
          width="120"
        />
      </v-col>
    </v-row>
    <div class="hr-divider"></div>
    <v-row style="margin-bottom: 30px">
      <v-col cols="12" class="pl-0 pl-sm-4">
        <v-data-table
          dense
          class="table"
          :headers="filteredHeaders"
          :items="claims"
          disable-pagination
          hide-default-footer
          :expanded="claims"
        >
          <template v-slot:[`item.Timestamp`]="{ item, index }">
            <td class="text-subtitle-2 text-left" :key="`timestamp-` + index">
              {{ $helpers.formatDate(item.Timestamp) }}
            </td>
          </template>
          <template v-slot:[`header.Timestamp`]="{ header, index }">
            <th
              class="text-subtitle-2 text-left"
              :key="`timestamp-h` + index"
              style="width: 100px"
            >
              {{ header.text }}
            </th>
          </template>
          <template v-slot:[`header.Identifier`]="{ header, index }">
            <th
              class="text-subtitle-2 text-left"
              :key="`timestamp-h` + index"
              style="width: 100px"
            >
              {{ header.text }}
            </th>
          </template>
          <template v-slot:[`item.Identifier`]="{ item, index }">
            <td
              class="text-subtitle-2 text-left"
              style="font-weight: 700; padding-left: 5px !important"
              :key="`ident-` + index"
            >
              {{ item.Identifier }}
            </td>
          </template>
          <template v-slot:[`item.Coverage`]="{ item, index }">
            <td class="text-subtitle-2 text-left" :key="`coverages-` + index">
              {{ getCoverageNames(item) }}
              <!-- {{translate2(item.CurrentClaimData.Benefit.Benefit, "Name")}} -->
            </td>
          </template>
          <template v-slot:[`item.ClaimedAmount`]="{ item, index }">
            <td
              class="text-subtitle-2 text-left"
              :key="`claimed-` + index"
              style="width: 80px"
            >
              ${{ calculateClaimedAmount(item) }}
            </td>
          </template>
          <template v-slot:[`item.Patients`]="{ item, index }">
            <td class="text-subtitle-2 text-left" :key="`patients-` + index">
              {{ getPatientNamesSubmitted(item) }}
            </td>
          </template>
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template v-slot:[`item.Patient`]="{ item }">
            <td class="text-subtitle-2 text-left">
              {{ getPatientNames(item) }}
            </td>
          </template>
          <template v-slot:[`item.PaidTo`]="{ item }">
            <td class="text-subtitle-2 text-left">
              {{ formatPaidTo(item.PaidTo) }}
            </td>
          </template>
          <template v-slot:[`item.ChequeStatus`]="{ item }">
            <td class="text-subtitle-2 text-left">
              {{ formatChequeStatus(item.ChequeStatus) }}
            </td>
          </template>
          <template v-slot:[`item.StatusDate`]="{ item }">
            <td class="text-subtitle-2 text-left">
              {{ $helpers.formatDate(item.StatusDate) }}
            </td>
          </template>
          <template v-slot:[`item.ChequeAmount`]="{ item }">
            <td class="text-subtitle-2 text-left">
              {{ $helpers.toCurrency(item.ChequeAmount) }}
            </td>
          </template>
          <template v-slot:[`item.TotalSubmitted`]="{ item }">
            <td class="text-subtitle-2 text-left">
              {{ $helpers.toCurrency(item.TotalSubmitted) }}
            </td>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td
              class="px-0"
              :colspan="headers.length"
              style="width: 100%; background-color: white; padding: 0 0"
            >
              <claim-detail
                :hideProofs="true"
                :claim="item"
                @preview-proof="$emit('preview-proof', $event)"
              />
            </td>
          </template>
          <!-- <template v-slot:footer>
            <div class="hr-divider"></div>
          </template> -->
        </v-data-table>
      </v-col>
    </v-row>
  </section>
</template>

<script>
// import pdf from "vue-pdf";
import { mapGetters, mapActions } from "vuex";
import masker from "vue-the-mask/src/masker";
import { tokens } from "vue-the-mask";
import { translate2 } from "@/trans2";
import ClaimDetail from "@/components/Claims/ClaimDetail.vue";
export default {
  components: {
    ClaimDetail,
  },
  props: {
    // member: {
    //   type: Object,
    //   default: () => {},
    // },
    claims: Array,
    headers: Array,
    dates: Array,
    title: String,
    planName: String,
  },
  data() {
    return {
      // internalMember: {},
      // fetchedAddress: undefined,
      // telephoneMask: "(###) ### - ####",
      logoForHtml: null,
      btnListeners: []
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("common", [
      "certificateLabel",
      // "planAdministratorName",
      "logo",
    ]),
    filteredHeaders() {
      return this.headers.filter((h) => {
        h.sortable = false;
        return (
          h.value !== "Print" &&
          h.value !== "data-table-select" &&
          h.value !== "data-table-expand" &&
          h.value !== "Proof" &&
          h.value !== "Actions"
        );
      });
    },
  },
  mounted() {
    // this.toBase64();
    // this.startDownload();
    this.$emit("loaded");
  },
  beforeDestroy() {
    this.btnListeners.forEach(({ btn, listener }) => {
      btn.removeEventListener("load", listener);
    });
  },
  watch: {
    // member: {
    //   handler(v) {
    //     if (v) {
    //       this.internalMember = JSON.parse(JSON.stringify(v));
    //       this.fetchedAddress = this.$helpers.formatDrawbridgeAddress(
    //         v.Address
    //       );
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  methods: {
    ...mapActions("common", ["loadUserProfileData"]),

    startDownload() {
      let imageURL = this.logo;

      const listener = this.imageReceived;
      let downloadedImg = new Image();
      downloadedImg.crossOrigin = "Anonymous";
      downloadedImg.addEventListener("load", listener, false);
      downloadedImg.src = imageURL;
      
      this.btnListeners.push({downloadedImg, listener});
    },

    imageReceived(downloadedImg) {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = downloadedImg.width;
      canvas.height = downloadedImg.height;

      context.drawImage(downloadedImg, 0, 0);

      this.logoForHtml = canvas.toDataURL("image/png");
    },

    // formatPhone(v) {
    //   return masker(v, this.telephoneMask, true, tokens);
    // },
    // getPatientNames(claim) {
    //   let patients = {};
    //   claim.ClaimHistoryDetails.forEach((c) => {
    //     patients[this.$helpers.capitalize(c.PatientName).trim()] = true;
    //   });
    //   return Object.keys(patients).join(", ");
    // },
    getPatientNames(claim) {
      const patients = claim.Claims.map((c) => {
        return c.CurrentClaimData.FirstName + " " + c.CurrentClaimData.LastName;
      });
      return [...new Set(patients)].join(", ");
    },
    getPatientNamesSubmitted(claim) {
      const patients = {};
      // eslint-disable-next-line no-unused-vars
      const patientNames = claim.Claims.map((c) => {
        // if (c.DependantId) {
        //   const dependant = this.dependants.find(
        //     (d) => d.DependantId === c.DependantId
        //   );
        //   if (dependant) {
        //     patients[dependant.FullName] = true;
        //     return dependant.FullName;
        //   }
        //   return null;
        // } else {
        //   const dependant = this.dependants.find(
        //     (d) => d.MemberId === "7381bafb-3ee5-42d6-9789-dcf74d29e2c1"
        //     // (d) => d.MemberId === c.MemberId
        //   );
        //   if (dependant) {
        //     patients[dependant.FullName] = true;
        //     return dependant.FullName;
        //   }
        // }
        // console.log(c);
        const fullName = c.FirstName + " " + c.LastName;
        patients[fullName] = true;
        return fullName;
      }).join(", ");
      return Object.keys(patients).join(", ");
    },
    formatPaidTo(paidTo) {
      if (!paidTo) return;
      let paidToTrimmed = paidTo.trim();
      if (paidToTrimmed !== "M" && paidToTrimmed !== "P") paidToTrimmed = "P";
      return this.$helpers.formatEnumModel(
        paidToTrimmed,
        "PaidTo",
        this.$vuetify.lang.current
      );
    },
    getCoverageNames(claim) {
      const coverages = claim.Claims.map((c) => {
        return translate2(c.CurrentClaimData.PlanBenefit.Benefit, "Name");
      });
      return [...new Set(coverages)].join(", ");
    },

    calculateClaimedAmount(claim) {
      let claimsTotal = 0;
      let claimsCob = 0;
      for (let c of claim.Claims) {
        claimsCob = claimsCob + c.CurrentClaimData.COBAmount;
        claimsTotal = claimsTotal + c.CurrentClaimData.ExpenseAmount;
      }
      return (claimsTotal - claimsCob).toFixed(2);
    },
    // formatChequeStatus(chequeStatus) {
    //   if (!chequeStatus) return;
    //   let chequeStatusTrimmed = chequeStatus.trim();
    //   const value = this.$t(
    //     `components.claims_history.cheque_status.${chequeStatusTrimmed}`
    //   );
    //   return value ?? "";
    // },
    translate2(item, field) {
      return translate2(item, field);
    },
  },
};
</script>
<style scoped>
.member-labels {
  font-size: 12px;
  padding: 1px 0;
}
.member-values {
  font-size: 12px;
  font-weight: 600;
}
.table >>> tr:hover {
  background-color: transparent !important;
}
.table >>> td {
  font-size: 0.75rem !important;
  font-weight: 500;
  text-align: left;
  padding-left: 4px !important;
}
.provider-text {
  font-size: 1rem;
  font-weight: 600;
}
.summary-text {
  font-size: 0.875rem;
  font-weight: 500;
  padding-bottom: 0;
  margin: 0 0;
  line-height: 1.1 !important;
}
.date-text {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.1 !important;
}
.pdf-content {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  width: 100%;
  background: #fff;
}
.hr-divider {
  border-bottom: 1px solid rgb(163, 163, 163);
  height: 10px;
  color: red;
}
.table >>> th {
  background-color: rgb(236, 236, 236) !important;
  color: black !important;
  font-size: 10px !important;
  height: 24px !important;
  padding: 0 4px !important;
  text-align: left;
  line-height: 1.1;
  font-weight: normal;
}
.table >>> td {
  font-size: 9px !important;
}
</style>
